import { useRouter } from "next/router";
import { useMemo } from "react";
import url from "url";
import normalizeQuery from "../util/normalize-route-query";

const useCustomRouter = () => {
  const router = useRouter();

  return useMemo(() => {
    const { asPath, push, replace, prefetch, ...rest } = router || {
      asPath: "",
    };
    const parsed = url.parse(asPath, true);
    const { pathname, query } = parsed;
    const location = {
      pathname,
      search: normalizeQuery(query),
    };

    return {
      location,
      router: {
        asPath,
        location,
        push,
        replace,
        prefetch,
        pushRoute: (...args) => {
          console.warn("pushRoute has been deprecated, use push");
          return push(...args);
        },
        replaceRoute: (...args) => {
          console.warn("replaceRoute has been deprecated, use replace");
          return replace(...args);
        },
        prefetchRoute: (...args) => {
          console.warn("prefetchRoute has been deprecated, use replace");
          return prefetch(...args);
        },
        ...rest,
      },
    };
  }, [router]);
};

export default useCustomRouter;
